<template>
  <div class="filter-status btnHover">
    <el-dropdown trigger="click" :hide-on-click="false">
      <span class="el-dropdown-link">
        <i class="icon iconfont iconicon_task_list"></i>
        清单筛选 {{task_list_ids.length ? task_list_ids.length : ''}}
      </span>
      <el-dropdown-menu slot="dropdown" class="filter-status-dropdown">
        <div class="reset">
          <span class="title">清单筛选</span>
          <span class="btnHover btn" :class="{'disabled': isDisabled}" @click="reset">重置</span>
        </div>
        <el-dropdown-item
        v-for="item in dataset"
        :key="item.task_list_id"
        :command="item.task_list_id"
        >
        <toolTip :title="item.title"><span>{{item.title}}</span></toolTip>
        <el-switch v-model="item.value" size="mini" @change="switchChange"></el-switch>
          <!-- <i class="icon iconfont iconicon_selected_more_task" v-show="task_list_ids === item.task_list_ids"></i> -->
        </el-dropdown-item>

      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex'
export default {
  data() {
    return {
      isChange: false,
      dataset: []
    }
  },
  computed: {
    ...mapState('task/task', {
      taskList: state => state.taskList,
      task_list_ids: state => state.queryMsg.task_list_ids
    }),
    isDisabled() {
      return !(this.dataset.some(res => res.value)) || this.dataset.length === 0
    }
  },
  watch: {
    taskList() {
      if(this.dataset.length === 0) {
        this.dataset = JSON.parse(JSON.stringify(this.taskList))
        this.dataset.map(res => {
          this.$set(res, 'value', false)
        })
      }
    }
  },
  methods: {
    ...mapMutations('task/task', ['set_taskList']),
    reset() {
      if(this.isDisabled) return
      this.dataset.map(res => {
        res.value = false
      })
      this.set_taskList(this.dataset.filter(res => res.value).map(res => res.task_list_id))
    },
    switchChange() {
      this.set_taskList(this.dataset.filter(res => res.value).map(res => res.task_list_id))
    }
  }
}
</script>
<style lang="scss">
.filter-task-list {
}
</style>
